// extracted by mini-css-extract-plugin
export default {"error":"NotFound_error__hxUbn"};